export const DEBOUNCE_SEARCH_TIME = 350;
export const DEBOUNCE_MISC_INPUT_TIME = 350;
export const THROTTLE_REFRESH_TIME = 3000;

